export const actions = {
  addPractice({ commit }, data) {
    commit("addPractice", data);
  },
  setAvailableLanguages({ commit }, data) {
    commit("setAvailableLanguages", data);
  }
};
